<template>
  <div class="analytics-container">
    <h2 class="page-title">sky mobi 数据</h2>
    <div class="table-section">
      <div class="toolbar">
        <div class="toolbar-left">
          <el-input
            v-model="filterPackage"
            clearable
            placeholder="按 package_name 筛选"
            style="width: 260px;"
            @keyup.enter="loadList"
          />
          <el-date-picker
            v-model="filterDate"
            type="date"
            placeholder="按日期筛选"
            value-format="YYYY-MM-DD"
            clearable
            style="width: 180px;"
          />
          <el-button type="primary" @click="loadList">查询</el-button>
        </div>
        <span class="total-hint">共 {{ total }} 条</span>
      </div>
      <el-table :data="statsList" border stripe v-loading="loading" style="width: 100%;">
        <el-table-column prop="date" label="日期" width="120" />
        <el-table-column prop="package_name" label="package_name" min-width="180" />
        <el-table-column prop="user_id" label="user_id" min-width="160" />
        <el-table-column prop="app_version" label="app_version" width="120" />
        <el-table-column prop="country" label="country" width="100" />
        <el-table-column prop="count" label="次数" width="90" />
        <el-table-column prop="language" label="language" width="100" />
        <el-table-column prop="timezone" label="timezone" min-width="140" />
        <el-table-column prop="updatedAt" label="更新时间" min-width="160" />
      </el-table>
      <div class="pager">
        <el-pagination
          v-model:current-page="page"
          v-model:page-size="pageSize"
          :total="total"
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next"
          @current-change="loadList"
          @size-change="onPageSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { SkyMobiStatsApi, type SkyMobiStatsItem } from '../../api/skyMobiStatsApi'

const statsList = ref<SkyMobiStatsItem[]>([])
const filterPackage = ref('')
const filterDate = ref('')
const loading = ref(false)
const total = ref(0)
const page = ref(1)
const pageSize = ref(50)

async function loadList() {
  loading.value = true
  try {
    const result = await SkyMobiStatsApi.getList({
      package_name: filterPackage.value.trim() || undefined,
      date: filterDate.value || undefined,
      skip: (page.value - 1) * pageSize.value,
      limit: pageSize.value,
    })
    statsList.value = result.list
    total.value = result.total
  } catch (error: any) {
    ElMessage.error(error?.response?.data?.message || error?.message || '加载失败')
  } finally {
    loading.value = false
  }
}

function onPageSizeChange() {
  page.value = 1
  loadList()
}

onMounted(() => {
  loadList()
})
</script>

<style scoped>
.analytics-container {
  padding: 8px;
}
.page-title {
  margin: 0 0 16px;
  font-size: 20px;
}
.table-section {
  background: var(--el-bg-color);
  padding: 16px;
  border-radius: 8px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  gap: 12px;
}
.toolbar-left {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.total-hint {
  color: var(--el-text-color-secondary);
  font-size: 13px;
}
.pager {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
</style>
